import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Operation } from 'fast-json-patch';
import { ConfigurationService } from '../../../core/services/ConfigurationService';
import { ConfigurationState } from '../../../core/store/reducers';

import { QueryRequest, QueryResponse, TableSchema, TableSchemaCriteria } from '../models';

@Injectable()
export class SqlQueryService {
  constructor(private http: HttpClient, private configuration: ConfigurationService) {}

  getTableSchamas(criteria: TableSchemaCriteria): Observable<TableSchema[]> {
    return this.configuration.config$.pipe(
      switchMap((c: ConfigurationState) => {
        return this.http.get<TableSchema[]>(`${c.config.apiServer}api/${criteria.database}/query`);
      })
    );
  }

  runSqlQuery(request: QueryRequest): Observable<QueryResponse> {
    return this.configuration.config$.pipe(
      switchMap((c: ConfigurationState) => {
        return this.http.post<QueryResponse>(`${c.config.apiServer}api/${request.database}/query`, request);
      })
    );
  }
}
